<template>
  <div class="dashboard-block">
    <ul class="item-detail item-detail-package">
      <li>
        <div class="row">
          <div class="col-md-6 m-t-xs">
            <h3>Save as PDF</h3>
            <p v-if="!$vlastMode">Show friends and event organisers the progress of your request.</p>
          </div>
          <div v-if="$userIsAdmin" class="col-xs-12 col-sm-8 col-lg-3 spacer-y-1">
              <selectize
                  class="selectize selectize-control selectize-single"
                  name="marketing_source_admin"
                  :disable-delete="true"
                  :placeholder="'Audience'"
                  v-model="target"
                  :options="audience">
              </selectize>
          </div>
            <div class="col-xs-12 col-sm-4 col-lg-3 spacer-y-1" :class="{ 'col-md-offset-3': !$userIsAdmin }">
                <ladda-button
                button class="btn btn-primary pull-right w-full" :click="handleDownloadPdfCallback">
                <i class="fa fa-cloud-download"></i> Download
                </ladda-button>
            </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Selectize from '../ext/codium/CodiumSelectize'
import { helpers } from 'mixins/bookings'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  data () {
    return {
      audience: [],
      target: this.$user.role
    }
  },

  created () {
    // Setup the dropdown options if user is admin
    if (this.$userIsAdmin) {
      // Add admin
      this.audience.push({id: 'admin', text: 'Admin'})

      // Add client
      if (this.$activeClientModuleEnabled) {
        this.audience.push({id: 'client', text: this.$t('Client')})
      }

      // Add talent(s)
      this.audience.push({id: 'talent', text: 'Talent/Manager'})
    }
  },

  components: {
    Selectize
  },

  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('booking', ['getPdf']),

    handleDownloadPdfCallback () {
      this.trackEvent(this.analytics.V2.JobPdfDownloadEvent)
      return this.getPdf({ id: this.booking.id, role: this.target })
        .then(({ data: { file, name } }) => {
          window.open(`${file}?name=${name}`, '_blank')
        })
    }
  }
}
</script>
